// @ts-nocheck
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { supabase } from '@/lib/supabase';
import { useToast } from '@/hooks/use-toast';
import { invokeEdgeFunction } from "@/lib/invokeEdgeFunction";

const CommunicationProcessor: React.FC = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { toast } = useToast();

  const processCommunications = async () => {
    setIsProcessing(true);
    try {
      console.log('🔄 Manually processing communications...');
      
      const { data, error } = await invokeEdgeFunction('process-communications', {
        body: {}
      });

      if (error) {
        console.error('❌ Error processing communications:', error);
        toast({
          title: "Error",
          description: `Failed to process communications: ${error.message}`,
          variant: "destructive"
        });
        return;
      }

      console.log('✅ Communication processing result:', data);
      toast({
        title: "Success",
        description: `Processed ${data.processed || 0} communications. ${data.successful || 0} successful, ${data.failed || 0} failed.`,
      });

    } catch (error: any) {
      console.error('❌ Error calling process-communications:', error);
      toast({
        title: "Error",
        description: `Failed to process communications: ${error.message}`,
        variant: "destructive"
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle>Manual Communication Processing</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Process pending email and SMS communications manually.
        </p>
        <Button 
          onClick={processCommunications}
          disabled={isProcessing}
          className="w-full"
        >
          {isProcessing ? 'Processing...' : 'Process Communications'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default CommunicationProcessor;